exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parameters__invalid___1ILIm input {\n  border: 1px solid red; }\n\n.parameters__table___2erEm {\n  margin-bottom: 0; }\n  .parameters__table___2erEm td {\n    padding: 0;\n    position: relative; }\n  .parameters__table___2erEm input {\n    width: 100%; }\n\n.parameters__keyTip___FOVaX {\n  position: absolute;\n  right: 15px;\n  font-size: 20px;\n  top: 11px;\n  color: green; }\n\n.parameters__mandatory___2vsuD input {\n  font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"invalid": "parameters__invalid___1ILIm",
	"table": "parameters__table___2erEm",
	"keyTip": "parameters__keyTip___FOVaX",
	"mandatory": "parameters__mandatory___2vsuD"
};